import axios from 'axios';
import Cookies from 'js-cookie';
import { isPublicAuthRoute } from './authRoutes';

// Configuração base do Axios
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para adicionar token de autenticação.
//
// O token do jogo vive no cookie `jwt` (é o que auth.js, AdminService e os
// outros serviços leem). Este cliente procurava por 'authToken' no
// localStorage, chave que nada no projeto escreve: toda requisição feita por ele
// saía sem Authorization, e por isso a loja premium só funcionava com rotas
// abertas. O localStorage fica como segunda opção.
api.interceptors.request.use(
  (config) => {
    // Rotas publicas de auth quebram (401) se receberem um token invalido.
    if (isPublicAuthRoute(config.url)) {
      delete config.headers.Authorization;
      return config;
    }

    const token = Cookies.get('jwt')
      || localStorage.getItem('authToken')
      || sessionStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Num 401 de login/cadastro o usuario ja esta na tela certa: redirecionar
    // para /login so apagaria o erro exibido no formulario.
    if (error.response?.status === 401 && !isPublicAuthRoute(error.config?.url)) {
      // Token expirado ou inválido
      Cookies.remove('jwt');
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;